<template>
  <div>
    <div class="snackbar-container text-center">
      <v-snackbar
        color="borderDark"
        v-model="$store.state.showMessage"
        timeout="3000"
        >{{ $store.state.message }}</v-snackbar
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "SnackBarVT",
  props: {},
};
</script>
<style lang="scss" scoped>
.snackbar-container {
  max-width: 80vw;
}
</style>
